__webpack_require__.p = "/simple-crud-operation/";